import React from "react";
import Constants from "../../helpers/Constants";
import { Product } from "../../models/product";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import "./comparePanel.css";

const ComparePanel: React.FC<{
  selectedProducts: Product[];
  onClear: () => void;
  onRemove: (sku: string) => void;
}> = (props) => {
  const handleCompare = (event: any) => {
    if (
      props.selectedProducts.length > Constants.MaxProductsCompared ||
      props.selectedProducts.length <= 1
    ) {
      event.defaultPrevented = true;
      return;
    }
  };
  const handleCleare = () => {
    props.onClear();
  };
  const handleRemove = (sku: string) => {
    props.onRemove(sku);
  };

  return props.selectedProducts.length > 0 ? (
    <div className="compare-panel">
      <div className="compare-panel-label-section">
        <div className="compare-panel-label-text">Compare</div>
        <div className="compare-panel-label-tip">{`${props.selectedProducts.length} out of ${Constants.MaxProductsCompared} products`}</div>
      </div>
      <div className="compare-panel-img-section">
        {props.selectedProducts.map((product) => (
          <div className="compare-panel-img-wrap" key={product.sku}>
            <div className="compare-panel-img-container">
              <img
                className="compare-panel-image"
                alt={product.name}
                src={product.image}
              ></img>
              <div
                className="compare-panel-image-unselect"
                onClick={() => {
                  handleRemove(product.sku);
                }}
              >
                <FaTimes />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="compare-panel-action-section">
        <button onClick={handleCleare} className="compare-panel-action-clear">
          Clear ALL
        </button>
        {props.selectedProducts.length === 1 ? (
          <Button className="compare-panel-action-compare" variant="secondary" disabled>
            COMPARE (1)
          </Button>
        ) : (
          <Link
            to="/compare"
            onClick={handleCompare}
            state={props.selectedProducts.map((p) => p.id)}
          >
            <button className="compare-panel-action-compare">
              COMPARE ({props.selectedProducts.length})
            </button>
          </Link>
        )}
      </div>
      <div className="compare-panel-action-section-fullscreen">
        {props.selectedProducts.length === 1 ? (
          <span className="compare-panel-action-link-fullscreen">
            <Button className="compare-panel-action-compare-fullscreen" variant="secondary" disabled>
              COMPARE (1)
            </Button>
          </span>
        ) : (
          <Link
            to="/compare"
            className="compare-panel-action-link-fullscreen"
            onClick={handleCompare}
            state={props.selectedProducts.map((p) => p.id)}
          >
            <button className="compare-panel-action-compare-fullscreen">
              COMPARE ({props.selectedProducts.length})
            </button>
          </Link>
        )}
      </div>
    </div>
  ) : null;
};

export default ComparePanel;
